/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  HStack,
  Text,
} from '@chakra-ui/core';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import colors from '../../../../styles/colors';

interface DeactivateSalaryValidationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeactivateSalaryValidationModal = ({ isOpen, onConfirm, onCancel }: DeactivateSalaryValidationModalProps) => {
  const { t } = useTranslation('accountParameter');
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onCancel}
      size="2xl"
      leastDestructiveRef={cancelRef}
      isCentered
      closeOnOverlayClick={false}
    >
      <AlertDialogOverlay>
        <AlertDialogContent borderRadius="xl">
          <AlertDialogHeader fontSize="lg" fontWeight="bold" pt={6} px={6} data-testid="deactivate-salary-validation-modal-title">
            {t('requisitionPane.deactivateSalaryValidationModal.title')}
          </AlertDialogHeader>
          <AlertDialogBody px={6} py={4} data-testid="deactivate-salary-validation-modal-body">
            <Text fontSize="14px" color={colors.blue[500]} mb={2}>
              {t('requisitionPane.positionSalaryCeilingValidationDescription')}
            </Text>
            <Text fontSize="14px" fontWeight="bold">
              {t('requisitionPane.deactivateSalaryValidationModal.body')}
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter pb={6} px={6}>
            <HStack spacing={3}>
              <Button
                colorScheme="red"
                onClick={onCancel}
                data-testid="deactivate-salary-validation-modal-cancel-button"
                variant="solid"
                fontWeight="bold"
                px={6}
              >
                {t('requisitionPane.deactivateSalaryValidationModal.cancelBtn')}
              </Button>
              <Button
                colorScheme="blue"
                onClick={onConfirm}
                data-testid="deactivate-salary-validation-deactivate-button"
                variant="solid"
                fontWeight="bold"
                px={6}
              >
                {t('requisitionPane.deactivateSalaryValidationModal.allowBtn')}
              </Button>
            </HStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
